import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";
import { ActionFunctionArgs } from "react-router";

import OnboardingContent from "@/components/Onboarding/OnboardingContent";
import PageWrapper from "@/components/ui/PageWrapper";

export async function action({ request }: ActionFunctionArgs) {
  const data = await request.formData();
  const actionKey = data.get("actionKey") as string;

  const skipActionResponse = await fetch(
    `/api/client/skip_onboarding_action/${actionKey}`,
    {
      method: "POST",
    }
  );

  if (skipActionResponse.status !== 200) {
    return { ok: false };
  }

  return { ok: true };
}

function Onboarding() {
  const { t } = useTranslation("onboarding");

  return (
    <PageWrapper>
      <div className="mx-xl my-lg">
        <Typography step="3" as="h1" weight="bold" className="mb-sm">
          {t("title")}
        </Typography>
        <OnboardingContent />
      </div>
    </PageWrapper>
  );
}

export default Onboarding;
